export const QTY_DECIMALS = 4;

export function trimDecimals(num, maxDecimals = QTY_DECIMALS) {
    const value = Number(num || 0);
    if (!Number.isFinite(value)) return 0;
    // Round via the decimal string rather than truncating `value * factor`:
    // the float product of an exact 4dp value can land just below the integer
    // (9.1892 * 10000 -> 91891.99...) and truncation would shave a quantum off.
    return Number(value.toFixed(maxDecimals));
}

export function remainingQuantity(requested, received, extra = 0) {
    return Math.max(
        0,
        trimDecimals(
            Number(requested || 0) - Number(received || 0) - Number(extra || 0),
            QTY_DECIMALS
        )
    );
}

export function isQuantityFilled(received, requested) {
    return remainingQuantity(requested, received) <= 0;
}

/** Sum of per-line remaining; over-received lines contribute 0, not negative. */
export function allotmentRemainingFromRows(rows) {
    return trimDecimals(
        (rows || []).reduce(
            (sum, row) =>
                sum +
                remainingQuantity(
                    row?.requested_quantity,
                    row?.received_quantity
                ),
            0
        )
    );
}

/** Prefer API remaining_quantity; fall back to summing rows or group totals. */
export function resolveAllotmentRemaining(slip) {
    if (slip?.remaining_quantity != null && slip?.remaining_quantity !== "") {
        return trimDecimals(Number(slip.remaining_quantity) || 0);
    }
    if (Array.isArray(slip?.rows) && slip.rows.length > 0) {
        return allotmentRemainingFromRows(slip.rows);
    }
    return remainingQuantity(
        slip?.requested_quantity,
        slip?.received_quantity
    );
}
